import { z } from 'zod';
import { ETC_STATE_VALUE } from './etcTicketState';

const EtcTicketAccountSchema = z.object({
  id: z.string(),
  email: z.string(),
});

const EtcTicketOperatorNoteSchema = z.object({
  id: z.string(),
  operator: z.string(),
  content: z.string(),
  createDateTime: z.string(),
});

const EtcTicketSchema = z.object({
  id: z.string(),
  etcAutoPayEnrollmentId: z.string(), // 大概是遠通電收的 ID 吧
  account: EtcTicketAccountSchema,
  plateNumber: z.string(), // 建立 ticket 當下 snapshot 的車牌
  idNumber: z.string().nullable().default(null), // 建立 ticket 當下 snapshot 的身分證字號 / 居留證號
  taxIdNumber: z.string().nullable().default(null), // 建立 ticket 當下 snapshot 的公司統一編號
  state: z.enum(ETC_STATE_VALUE),
  amount: z.number().nullable().default(null),
  paymentId: z.string().nullable().default(null),
  completeDateTime: z.string().nullable().default(null),
  createDateTime: z.string(),
  updateDateTime: z.string(),
  reason: z.string().nullable().default(null),
  operatorNotes: z.array(EtcTicketOperatorNoteSchema).default([]),
  hasTransactionReceipt: z.boolean().nullable().default(null),
});

const EtcTicketSummarySchema = EtcTicketSchema.omit({
  operatorNotes: true,
});

type EtcTicketAccount = z.infer<typeof EtcTicketAccountSchema>;
type EtcTicketOperatorNote = z.infer<typeof EtcTicketOperatorNoteSchema>;
type EtcTicket = z.infer<typeof EtcTicketSchema>;
type EtcTicketSummary = z.infer<typeof EtcTicketSummarySchema>;

export {
  EtcTicketAccountSchema,
  EtcTicketOperatorNoteSchema,
  EtcTicketSchema,
  EtcTicketSummarySchema,
};

export type {
  EtcTicketAccount,
  EtcTicketOperatorNote,
  EtcTicket,
  EtcTicketSummary,
};
